module.exports = __webpack_public_path__ + "static/media/Vector_right.26c2705c.svg";